import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import EmptyState from '../../components/EmptyState';
import NotificationCard from '../../components/NotificationCard';
import MainTitle from '../../components/MainTitle';
import { scroller, Element } from 'react-scroll';
import Pagination from '@material-ui/lab/Pagination';
import { useHistory } from 'react-router-dom';
import { MESSAGES, OPINIONS } from '../../routes/';
import { updateNotificationPage } from '../../store/actions/UserAction';
import Snackbar from '../../components/Snackbar';

const notificationsImg = '/img/empty-state/notifications.svg';

const styles = () => ({
  mainTitle: {
    '@media (max-width: 768px)': {
      margin: '0 24px'
    }
  },
});

const Notifications = ({ classes, uid ,pagination ,updateNotificationPage, roleUser }) => {

const history = useHistory();
const [feedbackMessage, setOpenFeedbackMessage] = useState({
  open: false,
  message: '',
  variant: 'success',
});

useEffect(() => {
  
}, []);

const handleChangePage = async (event, value) => {
  try {
    updateNotificationPage(uid, value, 'lawyer')
    scroller.scrollTo('notificationsList', { smooth: true, offset: -64 });
  } catch (error) {
    throw error;
  }
};

const handleNotificationClick = (notificationType) => {
  if(notificationType === 'messages'){
    history.push(MESSAGES)
  }else if(notificationType === 'Opinion'){
    history.push(OPINIONS)
  }
}

const handleCloseFeedbackMessage = () => {
  setOpenFeedbackMessage({
    open: false,
    message: '',
    variant: 'success',
  });
};

return (
  <>
  {pagination && pagination.data && pagination.data.length > 0 ? (
    <div style={{ width: '100%' }}>
        <div style={{ maxWidth: 824, margin: 'auto', paddingBottom: 80 }}>
          <div className={classes.mainTitle}>
            <MainTitle
              title="Notificaciones"
              subtitle="Es importante mantenerte al día para la gestión de tu tiempo"
            />
          </div>
          <br />
          <br />
          <Element name="notificationsList">
            {pagination.data &&
              pagination.data.length &&
              pagination.data.map((notification) => {
                
                return (
                  <div key={notification.uid} style={{ maxWidth: 824 }}>
                    <NotificationCard
                      elevation={1}
                      square={false}
                      notification={notification}
                      //notificationsLaw={pagination.data }
                      sender={notification.messageNotification.title}
                      type={'notification.type'}
                      description={
                        <>

                          {notification.messageNotification.instruction}
                          <br />
                          {notification.messageNotification.text}
                        </>
                      }
                      uidLawyer={uid}
                      notificationUserType='notifications'
                      date={notification.createdAt._seconds}
                      featured={notification.featured}
                      read={notification.read}
                      mediaWidth={isMobile ? 32 : 92}
                      mediaHeight={isMobile ? 32 : 92}
                      mediaMargin={isMobile ? '0 8px 0 0' : '0 16px 0 0'}
                      titleFontSize={isMobile ? 16 : 18}
                      descriptionFontSize={isMobile ? 12 : 14}
                      footerFontSize={isMobile ? 10 : 12}
                      featuredPositionRight={isMobile ? 16 : 20}
                      optionsButtonMargin={isMobile ? '10px 0 0' : '10px 0 0'}
                      cardMargin={isMobile ? 0 : '0 0 8px'}
                      cardPadding={isMobile ? 12 : 16}
                      descriptionMargin={isMobile ? '0 0 8px' : '4px 0'}
                      handleNotificationClick={handleNotificationClick}
                      roleUser = {roleUser}
                      uidUser = {uid}
                      setOpenFeedbackMessage = {setOpenFeedbackMessage}
                    />
                  </div>
                );
              })}

          </Element>
            {pagination.totalPages && pagination.totalPages <= 1 ?
              null :
              pagination.totalPages === 0 ? 
              null :
              <div style={{ width: '100%', margin: '0 auto 0 23%' }}>
                <Pagination 
                  color="primary"
                  count={pagination.totalPages}
                  page={pagination.actualpage}
                  onChange={handleChangePage}
                />
              </div>
            }
        </div>
        <Snackbar
          open={feedbackMessage.open}
          variant={feedbackMessage.variant}
          message={feedbackMessage.message}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '70px' : '80px'}
        />
      </div>
  ) :( <EmptyState
      title="Estamos atentos a notificarte de inmediato."
      subtitle="En cuanto tengas una respuesta o se te contacte por primera ocasión, nosotros te avisaremos al instante."
      img={notificationsImg}
      // handleClick={() => this.props.history.push('/')}
      handleClick={() => this.props.history.push('/dashboard/')}
      callToAction="Continuar navegando"
    />)}
  </>)

}

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  roleUser: state.authClient.role,
  pagination: state.authClient.notificationsPageLoad
});

const mapDispatchToProps = dispatch => ({
  updateNotificationPage: (uid, page, type) => dispatch(updateNotificationPage(uid, page, type)),
  // deleteNotificationPage: () => dispatch(deleteNotificationPage(uid, page))
}); 


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Notifications));